export default __webpack_public_path__ + "static/media/Kabel-Regular.ttf.bca13665.woff";